import { createContext } from "react"
import { ProviderProps, GetSetToken } from "./AuthenticationContext.types"

const AuthenticationContext = createContext<GetSetToken>(["", () => {}])

export default AuthenticationContext

export const AuthenticationProvider = ({ children, value }: ProviderProps) => (
  <AuthenticationContext.Provider value={value}>
    {children}
  </AuthenticationContext.Provider>
)
